import React, { useRef } from 'react';
import * as S from './BlogList.styles';
import { BlogPost } from '@/typings/blog';
import LandingPageBanner from '@/components/LandingPageBanner/LandingPageBanner';
import { Tag } from '@/typings/tag';
import BlogPostCard from '@/components/BlogPostCard/BlogPostCard';
import TagsSelect from '@/components/TagsSelect/TagsSelect';
import { Variants, motion } from 'framer-motion';

type BlogListProps = {
  blogPosts: BlogPost[];
  selectedTag?: Tag;
  tags: Tag[];
};

const BlogList: React.FC<BlogListProps> = ({ blogPosts, selectedTag, tags }) => {
  const scrollRef = useRef(null);
  const itemMotion: Variants = {
    hidden: { opacity: 0, y: 50 },
    show: {
      transition: {
        mass: 1,
        duration: 0.6,
        type: 'tween',
      },
      opacity: [0, 0.2, 0.3, 0.5, 1],
      y: 0,
      height: '100%',
    },
  };

  return (
    <S.Wrapper>
      <LandingPageBanner
        title={selectedTag?.title || 'Prime Wine'}
        banner={selectedTag?.banner || '/assets/blog-default-banner.jpg'}
      />
      <S.Content>
        {tags.length > 0 && (
          <TagsSelect label="CATEGORIA:" categories={tags} selectedCategory={selectedTag} />
        )}

        {blogPosts.length > 0 ? (
          <S.PostsWrapper length={blogPosts.length}>
            {blogPosts.map((blogPost) => (
              <motion.div
                key={blogPost.id}
                initial="hidden"
                whileInView="show"
                variants={itemMotion}
                viewport={{ root: scrollRef, once: true }}
              >
                <BlogPostCard key={blogPost.id} {...blogPost} />
              </motion.div>
            ))}
          </S.PostsWrapper>
        ) : (
          <p className="empty-message">
            {selectedTag
              ? 'Não temos nenhuma publicação disponível para a categoria selecionada'
              : 'Não temos nenhuma publicação disponível no momento'}
          </p>
        )}
      </S.Content>
    </S.Wrapper>
  );
};

export default BlogList;
